export const commonChartOptions = {
  animationEnabled: true,
  title: {
    fontSize: 14,
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontColor: "#737474",
    horizontalAlign: "left",
    padding: { bottom: 20 },
  },
  axisY: {
    includeZero: true,
    gridThickness: 0,
    labelFontSize: 10,
    labelFontFamily: "Montserrat",
    labelFontWeight: 500,
  },
  axisX: {
    labelFontSize: 10,
    labelFontFamily: "Montserrat",
    labelFontWeight: 500,
    tickLength: 0,
    lineThickness: 0,
    gridThickness: 0,
  },
  legend: {
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: 10,
  },
  indexLabelOptions: {
    fontColor: "#00403C",
    fontSize: 10,
    fontFamily: "Montserrat",
    fontWeight: 600,
  },
};
